/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resource = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepKernel = require('deep-kernel');

var _deepKernel2 = _interopRequireDefault(_deepKernel);

var _Instance = require('./Resource/Instance');

var _MissingResourceException = require('./Exception/MissingResourceException');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Bundle resource
 */
let Resource = exports.Resource = function (_Kernel$ContainerAwar) {
  _inherits(Resource, _Kernel$ContainerAwar);

  /**
   * @param {Object} resources
   */
  function Resource() {
    let resources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Resource);

    var _this = _possibleConstructorReturn(this, (Resource.__proto__ || Object.getPrototypeOf(Resource)).call(this));

    _this._resources = resources;
    _this._actionsConfig = {};

    _this._baseUrl = null;
    return _this;
  }

  /**
   * @param {String} url
   * @returns {Resource}
   */


  _createClass(Resource, [{
    key: 'baseUrl',
    value: function baseUrl(url) {
      this._baseUrl = url;

      return this;
    }

    /**
     * @param {String} sourceId
     * @returns {Object|null}
     */

  }, {
    key: 'getActionConfig',
    value: function getActionConfig(sourceId) {
      return this._actionsConfig.hasOwnProperty(sourceId) ? this._actionsConfig[sourceId] : null;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'has',


    /**
     * @param {String} identifier
     * @returns {Boolean}
     */
    value: function has(identifier) {
      return this._resources[this.microservice.identifier].hasOwnProperty(identifier);
    }

    /**
     * @param {String} identifier (e.g @microservice_identifier:resource_name[:action_name])
     * @returns {ResourceInstance}
     */

  }, {
    key: 'get',
    value: function get(identifier) {
      let parsedIdentifier = this._parseResourceIdentifier(this._resolveIdentifier(identifier) // it also binds 'working' microservice to this instance
      );

      let resourceIdentifier = parsedIdentifier.resource;
      let actionIdentifier = parsedIdentifier.action;

      let microserviceIdentifier = this.microservice.identifier;

      if (!this.has(resourceIdentifier)) {
        throw new _MissingResourceException.MissingResourceException(microserviceIdentifier, resourceIdentifier);
      }

      let resource = this._resources[microserviceIdentifier][resourceIdentifier];

      // inject dependencies (@todo - inject kernel instance instead)
      resource.cache = this.container.get('cache');
      resource.security = this.container.get('security');
      resource.validation = this.container.get('validation');
      resource.log = this.container.get('log');
      resource.contextProvider = this.kernel.contextProvider;
      resource.baseUrl = this._baseUrl;

      return actionIdentifier ? resource.action(actionIdentifier) : resource;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: '_parseResourceIdentifier',


    /**
     * @param {String} identifier
     * @returns {Object}
     * @private
     */
    value: function _parseResourceIdentifier(identifier) {
      let parts = identifier.split(':').map(part => {
        return part.trim();
      });

      return {
        resource: parts.shift(),
        action: parts.length > 0 ? parts.join(':') : null
      };
    }

    /**
     * Booting a certain service
     *
     * @param {Kernel} kernel
     * @param {Function} callback
     */

  }, {
    key: 'boot',
    value: function boot(kernel, callback) {
      let resourcesVector = [];

      for (let microserviceKey in kernel.microservices) {
        if (!kernel.microservices.hasOwnProperty(microserviceKey)) {
          continue;
        }

        let microservice = kernel.microservices[microserviceKey];

        this._resources[microservice.identifier] = {};

        for (let resourceName in microservice.rawResources) {
          if (!microservice.rawResources.hasOwnProperty(resourceName)) {
            continue;
          }

          let resource = new _Instance.Instance(resourceName, microservice);

          resource.localBackend = this.localBackend;
          resource.isBackend = kernel.isBackend;

          this._resources[microservice.identifier][resourceName] = resource;

          resourcesVector.push(resource);

          let actionsConfig = resource.actionsConfig;

          for (let actionSourceId in actionsConfig) {
            if (!actionsConfig.hasOwnProperty(actionSourceId)) {
              continue;
            }

            this._actionsConfig[actionSourceId] = actionsConfig[actionSourceId];
          }
        }
      }

      callback();
    }
  }, {
    key: 'actionsConfig',
    get: function get() {
      return this._actionsConfig;
    }
  }, {
    key: 'list',
    get: function get() {
      let map = {};

      for (let microservice in this._resources) {
        if (!this._resources.hasOwnProperty(microservice)) {
          continue;
        }

        map[microservice] = Object.keys(this._resources[microservice]);
      }

      return map;
    }
  }]);

  return Resource;
}(_deepKernel2.default.ContainerAware);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource.js
// module id = 414
// module chunks = 0